<template>
  <div class="alerta">
    {{ alerta }}
  </div>
</template>

<script>
export default {
  name: "AlertaCenario",
  props: {
    alerta: String
  }
};
</script>

<style lang="scss" scoped>
.alerta {
  color: #856404;
  background: #fff3cd;
  border-color: #ffeeba;
  padding: 10px 15px;
  margin: 12px 0;
}
</style>
